function cov_fnkm0h9ur() {
  var path = "/app/src/components/long-term-content/components/installment-item/installment-item.tsx";
  var hash = "936298438aa149a887ebbf931a6b8db3637d7923";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/long-term-content/components/installment-item/installment-item.tsx",
    statementMap: {
      "0": {
        start: {
          line: 22,
          column: 31
        },
        end: {
          line: 78,
          column: 1
        }
      },
      "1": {
        start: {
          line: 32,
          column: 23
        },
        end: {
          line: 32,
          column: 38
        }
      },
      "2": {
        start: {
          line: 33,
          column: 18
        },
        end: {
          line: 33,
          column: 56
        }
      },
      "3": {
        start: {
          line: 35,
          column: 2
        },
        end: {
          line: 77,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 22,
            column: 31
          },
          end: {
            line: 22,
            column: 32
          }
        },
        loc: {
          start: {
            line: 31,
            column: 13
          },
          end: {
            line: 78,
            column: 1
          }
        },
        line: 31
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 46,
            column: 53
          },
          end: {
            line: 46,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 46,
            column: 53
          },
          end: {
            line: 46,
            column: 57
          }
        }, {
          start: {
            line: 46,
            column: 61
          },
          end: {
            line: 46,
            column: 78
          }
        }],
        line: 46
      },
      "1": {
        loc: {
          start: {
            line: 62,
            column: 11
          },
          end: {
            line: 64,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 62,
            column: 11
          },
          end: {
            line: 62,
            column: 47
          }
        }, {
          start: {
            line: 62,
            column: 51
          },
          end: {
            line: 62,
            column: 69
          }
        }, {
          start: {
            line: 63,
            column: 12
          },
          end: {
            line: 63,
            column: 37
          }
        }],
        line: 62
      },
      "2": {
        loc: {
          start: {
            line: 67,
            column: 7
          },
          end: {
            line: 75,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 67,
            column: 7
          },
          end: {
            line: 67,
            column: 24
          }
        }, {
          start: {
            line: 68,
            column: 8
          },
          end: {
            line: 74,
            column: 14
          }
        }],
        line: 67
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "936298438aa149a887ebbf931a6b8db3637d7923"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_fnkm0h9ur = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_fnkm0h9ur();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import cn from 'classnames';
import React from 'react';
import { LimitedTimeOfferBadge } from 'src/components/long-term-content/components/limited-time-offer-badge';
import { Typography } from 'src/components/v2/typography';
import { COUNTRY_NAME_BY_CURRENCY_MAP } from 'src/constants/country-name-by-currency-map';
import { SUBVENTION_COUNTRY } from 'src/constants/subvention-country';
import { useAppContext } from 'src/context/store/app-provider';
import styles from './styles.css';
cov_fnkm0h9ur().s[0]++;
export var InstallmentItem = function InstallmentItem(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    paymentsInfo = _ref.paymentsInfo,
    key = _ref.key,
    list = _ref.list,
    isLimitedTimeOffer = _ref.isLimitedTimeOffer,
    isGreenSubtitle = _ref.isGreenSubtitle,
    additionalContent = _ref.additionalContent;
  cov_fnkm0h9ur().f[0]++;
  var _ref2 = (cov_fnkm0h9ur().s[1]++, useAppContext()),
    currency = _ref2.currency;
  var country = (cov_fnkm0h9ur().s[2]++, COUNTRY_NAME_BY_CURRENCY_MAP[currency]);
  cov_fnkm0h9ur().s[3]++;
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.container, _defineProperty({}, styles.list, list)),
    key: key,
    "data-test": "payment-plan"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.content, _defineProperty(_defineProperty({}, styles.contentList, list), styles.contentListWithAdditionalContent, (cov_fnkm0h9ur().b[0][0]++, list) && (cov_fnkm0h9ur().b[0][1]++, additionalContent)))
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: styles.titleContainer
  }, /*#__PURE__*/React.createElement("span", null, title), /*#__PURE__*/React.createElement("span", {
    className: styles.paymentsInfo
  }, paymentsInfo)), /*#__PURE__*/React.createElement("div", {
    className: styles.bottomContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption1",
    className: cn(styles.description, _defineProperty({}, styles.free, isGreenSubtitle))
  }, subtitle), (cov_fnkm0h9ur().b[1][0]++, SUBVENTION_COUNTRY.includes(country)) && (cov_fnkm0h9ur().b[1][1]++, isLimitedTimeOffer) && (cov_fnkm0h9ur().b[1][2]++, /*#__PURE__*/React.createElement(LimitedTimeOfferBadge, null)))), (cov_fnkm0h9ur().b[2][0]++, additionalContent) && (cov_fnkm0h9ur().b[2][1]++, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.additionalContent, _defineProperty({}, styles.additionalContentList, list))
  }, additionalContent)));
};